import React from 'react';
import PropTypes from 'prop-types';

import Box from '@mui/material/Box';

import AdditionalDetailsCard from './AdditionalDetailsCard';
import DepartmentsCard from './DepartmentsCard';
import LocationsWorkersCompCard from './LocationsWorkersCompCard';
import PositionDetailsCard from './PositionDetailsCard';

const rootSx = { display: 'flex', flexDirection: 'column', gap: '16px' };

const OverviewTab = (props) => (
  <Box sx={rootSx}>
    <PositionDetailsCard {...props} />
    <LocationsWorkersCompCard {...props} />
    <DepartmentsCard {...props} />
    <AdditionalDetailsCard {...props} />
  </Box>
);

OverviewTab.propTypes = {
  positionTemplate: PropTypes.shape({}).isRequired,
  saveField: PropTypes.func.isRequired,
  getStatus: PropTypes.func.isRequired,
};

export default OverviewTab;
